import { Flex, Text } from "@radix-ui/themes";
import { FC } from "react";

interface TextFieldRowProps {
  value?: string | null;
}

export const TextFieldRow: FC<TextFieldRowProps> = ({ value }) => {
  if (!value) {
    return <div />;
  }

  return (
    <Flex align="center" justify="start" pl="1" pr="1">
      <Text size="1">{value}</Text>
    </Flex>
  );
};
